import { Component, input, output } from '@angular/core';
import type { Tags } from '../../interfaces/glossaryInterface';
import { GlossaryTagComponent } from '../glossary-tag/glossary-tag.component';
import { NgClass } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faSolidFilter } from '@ng-icons/font-awesome/solid';

@Component({
    selector: 'app-glossary-tag-filters',
    imports: [GlossaryTagComponent, NgClass, NgIcon],
    providers: [provideIcons({ faSolidFilter })],
    templateUrl: './glossary-tag-filters.component.html',
    styleUrl: './glossary-tag-filters.component.scss'
})
export class GlossaryTagFiltersComponent {
  tags = input.required<Tags>();
  update = output<Tags>();
  protected selectedTags: Tags = [];

  onTagClicked(tag: string) {
    if (this.selectedTags.includes(tag)) {
      this.selectedTags = this.selectedTags.filter(t => t !== tag);
    } else {
      this.selectedTags = [...this.selectedTags, tag];
    }
    this.update.emit(this.selectedTags);
  }
}
